import React from 'react';
import { ReactComponent as ClockIcon } from '../../images/clock_outlined.svg';
import { PriorityProjectStatus } from '../../model';
import { StateButtonStyled } from './StateButtonStyled';

interface BtnConfig {
  label: string;
  icon?: React.ReactNode;
  className?: string;
}

export const projectStatusToBtnState = (status: PriorityProjectStatus) => {
  switch (status) {
    case PriorityProjectStatus.Current:
      return BtnState.Current;
    case PriorityProjectStatus.Future:
      return BtnState.Future;
    default:
      return BtnState.Future;
  }
};

export enum BtnState {
  Current = 'current',
  Future = 'future',
}

export const btnConfig: Record<BtnState, BtnConfig> = {
  [BtnState.Current]: {
    label: 'Доступно сейчас',
  },
  [BtnState.Future]: {
    label: 'Планируется',
    icon: (
      <span style={{ marginRight: '4px' }}>
        <ClockIcon />
      </span>
    ),
    className: 'future',
  },
};

export const StateButton = ({ state }: { state: BtnState }) => {
  const icon = btnConfig[state]?.icon;
  const label = btnConfig[state]?.label;
  return (
    <StateButtonStyled className={state}>
      {icon} <span> {label}</span>
    </StateButtonStyled>
  );
};
